// extracted by mini-css-extract-plugin
export default {"curultai":"Curultai_curultai__CNVmi","date":"Curultai_date__2F7MP","when":"Curultai_when__Cuq3T","desc":"Curultai_desc__qVTlg","title":"Curultai_title__AqoP2"};